module.exports = __webpack_public_path__ + "static/blackbg-35077eb22550cc78c46a9fce497d632c.jpeg";